import Vue from 'vue'
import Router from 'vue-router'
import Register from '@/components/Register'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        Auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/Login')
    },
    {
      path: '/vendor_portal',
      name: 'vednorlogin',
      component: () => import('@/components/VendorLogin')
    },
    {
      path: '/vendor_list',
      name: 'vendorList',
      component: () => import('@/components/vendor/DisplayList')
    },
    {
      path: '/forgot_password',
      name: 'forgotpassword',
      component: () => import('@/components/ForgotPassword')
    },
    {
      path: '/reset_password',
      name: 'resetpassword',
      component: () => import('@/components/ResetPassword')
    },
    {
      path: '/raffle',
      name: 'raffle_form',
      component: () => import('@/components/raffle/ExternalForm')
    },
    {
      path: '/tailgate',
      name: 'tailgate_form',
      component: () => import('@/components/tailgate/ExternalForm')
    },
    {
      path: '/ex_bsd',
      name: 'bsd_form',
      component: () => import('@/components/bsd/ExternalForm')
    },
    {
      path: '/bsd_liability',
      name: 'liabbsd_liabilityility',
      component: () => import('@/components/bsd/Liability')
    },
    {
      path: '/ex_brandingroom',
      name: 'br_form',
      component: () => import('@/components/brandingRoom/ExternalForm')
    },
    {
      path: '/ex_muttonBustin',
      name: 'mb_form',
      component: () => import('@/components/muttonBustin/ExternalForm')
    },
    {
      path: '/ex_mbpayment',
      name: 'mb_pay',
      component: () => import('@/components/muttonBustin/Externalpayment')
    },
    {
      path: '/ex_mbchamp',
      name: 'mbc_form',
      component: () => import('@/components/mbChampionship/ExternalForm')
    },
    {
      path: '/ex_mbchamppayment',
      name: 'mbc_pay',
      component: () => import('@/components/mbChampionship/Externalpayment')
    },
    {
      path: '/ex_cattledrive',
      name: 'cd_form',
      component: () => import('@/components/cattleDrive/ExternalForm')
    },
    {
      path: '/ex_cdpayment',
      name: 'cd_pay',
      component: () => import('@/components/cattleDrive/Externalpayment')
    },
    {
      path: '/ex_golf',
      name: 'golf_form',
      component: () => import('@/components/golf/ExternalForm')
    },
    {
      path: '/vendor_registration',
      name: 'vr_form',
      component: () => import('@/components/vendor/ExternalForm')
    },
    {
      path: '/accept_handbook',
      name: 'accept_handbook',
      component: () => import('@/components/handbook/ExternalForm')
    },
    {
      path: '/badge',
      name: 'badge',
      component: () => import('@/components/badge/ExternalForm')
    },
    {
      path: '/wrangler_form',
      name: 'wrangler_form',
      component: () => import('@/components/wrangler/ExternalForm')
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: () => import('@/components/ticket/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/components/Users'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/handbook',
      name: 'handbook',
      component: () => import('@/components/Handbook')
    },
    {
      path: '/accept_policy',
      name: 'accept_policy',
      component: () => import('@/components/AcceptPolicy')
    },
    {
      path: '/committee-list',
      name: 'committee-list',
      component: () => import('@/components/committees/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/committees/:committee/:currentYear',
      name: 'committees',
      component: () => import('@/components/committees/Committees'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('@/components/Contacts'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/components/Calendar'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/document',
      name: 'document',
      component: () => import('@/components/Document'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/committee-schedule/:committee/:currentYear/:committeeId',
      name: 'committee-schedule',
      component: () => import('@/components/schedule/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: () => import('@/components/myschedule/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings/mobile-types',
      name: 'mobile-types',
      component: () => import('@/components/settings/MobileTypes'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/components/settings/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/texting',
      name: 'texting',
      component: () => import('@/components/texting/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/election',
      name: 'election',
      component: () => import('@/components/Elections'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vote',
      name: 'vote',
      component: () => import('@/components/Vote'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/bsd-list',
      name: 'bsd-list',
      component: () => import('@/components/bsd/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/muttonbustin-list',
      name: 'muttonbustin-list',
      component: () => import('@/components/muttonBustin/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/mbchamp-list',
      name: 'mbchamp-list',
      component: () => import('@/components/mbChampionship/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/raffle-list',
      name: 'raffle-list',
      component: () => import('@/components/raffle/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/tailgate-list',
      name: 'tailgate-list',
      component: () => import('@/components/tailgate/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/cattledrive-list',
      name: 'cattledrive-list',
      component: () => import('@/components/cattleDrive/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/golf-list',
      name: 'golf-list',
      component: () => import('@/components/golf/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vendor-list',
      name: 'vendor-list',
      component: () => import('@/components/vendor/Enter'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vendor-booths',
      name: 'vendor-booths',
      component: () => import('@/components/vendor/Booths'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vendor-maps',
      name: 'vendor-maps',
      component: () => import('@/components/vendor/Maps'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/extern-maps',
      name: 'extern-maps',
      component: () => import('@/components/vendorExtern/Maps')
    },
    {
      path: '/vendor-accounting',
      name: 'vendor-accounting',
      component: () => import('@/components/vendor/Accounting'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table',
      name: 'table',
      component: () => import('@/components/Table'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table1',
      name: 'table1',
      component: () => import('@/components/Table1'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table2',
      name: 'table2',
      component: () => import('@/components/Table2'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table3',
      name: 'table3',
      component: () => import('@/components/Table3'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table4',
      name: 'table4',
      component: () => import('@/components/Table4'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vuedrag',
      name: 'vuedrag',
      component: () => import('@/components/VueDrag'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/members',
      name: 'members',
      component: () => import('@/components/Members'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/purchase_orders',
      name: 'purchase_orders',
      component: () => import('@/components/PurchaseOrders'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/emp',
      name: 'emp',
      component: () => import('@/components/Products'),
      meta: {
        Auth: true
      }
    },
    {
      path: '*',
      name: 'dashboard',
      component: () => import('@/components/dashboard/Dashboard'),
      meta: {
        Auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.Auth)) {
    if (!store.state.isUserLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js